import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" }); // Scroll to top-left corner
  }, [pathname]); // Run on every route change

  return null;
};

export default ScrollToTop;